import advertise from "./advertise"
export default advertise;
